// import something here

import { LocalStorage } from "quasar"
import { api } from "./axios"

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files
export default async ({ store }) => {
  const token = LocalStorage.getItem('auth._token')
  if (token) {
    try {
      const resp = await api.get('PE/students/profile/', { headers: {Authorization: `Token ${token}`}})
      api.defaults.headers.common['Authorization'] = `Token ${token}`
      // console.log(resp)
      store.dispatch('auth/profile', resp.data)
    } catch (error) {
      LocalStorage.remove('auth._token')
      console.log(error)
    }
  }
}
